import { useEffect, useRef } from 'react';
import UIkit from 'uikit';
import { historyKey } from './search-utils';

// Keep list-page contexts current without reopening the modal on each render.
export default function useRecordDetail({ id, account, load, onLoaded, target }) {
  const handlers = useRef({ load, onLoaded, target });
  handlers.current = { load, onLoaded, target };
  const scope = historyKey(account);
  useEffect(() => {
    if (!scope || !/^\d+$/.test(id || '')) return;
    let active = true;
    const current = handlers.current;
    current.load(id).then(async ({ data }) => {
      if (!active || !data) return;
      await current.onLoaded(data);
      if (active) UIkit.modal(current.target).show();
    }).catch(() => {
      if (active) UIkit.notification('Unable to open this record. Please try again.', { status: 'warning' });
    });
    return () => { active = false; };
  }, [id, scope]);
}
